export default {
    data() {
        return {
            email: 'DanlosAdrian@gmail.com',
            phone: '+34 687796445',
            linkedin: 'adrian-danlos',
            github: 'AdrianDanlos'
        }
    }
}